import { ActionContext } from 'vuex';

const _state: {
	language: Language;
} = {
	language: 'hu',
};

type State = typeof _state;
type Language = 'hu' | 'en';



export const LanguageModule = {
	namespaced: true,

	state: _state,

	getters: {
		GET_LANGUAGE: (state: State) => {
			return state.language;
		},
	},

	actions: {
		CHANGE_LANGUAGE: (context: ActionContext<State, State>, language: Language) => {
			context.commit('SET_LANGUAGE', language);
		},
	},

	mutations: {
		SET_LANGUAGE: (state: State, language: Language) => {
			state.language = language;
		},
	},
};
